import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import AlertsPage, { getDefaultPageData, getDefaultPageUI } from "components/pages/AlertsPage";
import Classes from "model";

export default function CaptureLessThanSelected(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);

    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
    .update([ "addEditAlertWidget", "alert", "type" ], "balanceAlert")
    .update([ "addEditAlertWidget", "alert", "alertMeWhen" ], "available balance")
    .update([ "addEditAlertWidget", "alert", "alertMeWhenBalanceIs" ], "less than")
    .submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
    .update([ "addEditAlertWidget", "form", "isActive" ], true)
    .submit();

    return <AlertsPage data={ data } ui={ ui } />;
}